const usTimezones: Record<string, { value: string; name: string }[]> = {
  US: [
    { value: 'America/Puerto_Rico', name: 'Puerto Rico (Atlantic)' },
    { value: 'America/New_York', name: 'New York (Eastern)' },
    { value: 'America/Chicago', name: 'Chicago (Central)' },
    { value: 'America/Denver', name: 'Denver (Mountain)' },
    { value: 'America/Phoenix', name: 'Phoenix (MST)' },
    { value: 'America/Los_Angeles', name: 'Los Angeles (Pacific)' },
    { value: 'America/Anchorage', name: 'Anchorage (Alaska)' },
    { value: 'Pacific/Honolulu', name: 'Honolulu (Hawaii)' },
  ],
};

export default usTimezones;
